import { sortBy } from 'lodash';
import type { GroupValidation } from '../types';

/**
 * Returns per-group validation for a PairMatcher widget.
 * Each entry: the pair the user formed + whether it matches an expected pair.
 *
 * Each expected pair is consumed on first match (deleted from the working set),
 * so a duplicate user pair will not find it again and is marked incorrect.
 */
export function getPairMatcherGroupResults(
  expected: string[][],
  result?: string[][],
): GroupValidation[] {
  if (!Array.isArray(result)) return [];
  const normalizeGroup = (g: string[]) => sortBy(g).join('|');
  const expectedKeys = new Set(expected.map(normalizeGroup));
  return result.map(group => {
    const key = normalizeGroup(group);
    if (expectedKeys.has(key)) {
      expectedKeys.delete(key);
      return { group, isCorrect: true };
    }
    return { group, isCorrect: false };
  });
}
